import { createFileRoute } from "@tanstack/react-router";
import ProductManager from "@/features/inventory/ProductManager";

export const Route = createFileRoute("/inventory/products")({
  component: ProductsPage,
});

function ProductsPage() {
  return (
    <div className="gap-4 flex flex-col grow min-h-0 w-full h-full">
      <ProductManager onClose={() => {}} />
    </div>
  );
}
